import React from "react";
import classNames from "classnames";

class DoctorPhoto extends React.Component {
  render() {
    const { name, photoUrl } = this.props;

    const style = classNames({
      "doctor-photo": true,
      "_has-photo": photoUrl
    });

    return (
      <div className={style}>
        {/* Include reference to use avatar background image */}
        <div className="avatar" />
        {photoUrl && <img src={photoUrl + "?d=280x330&mode=max"} alt={name} />}
      </div>
    );
  }
}

export default DoctorPhoto;
